import { useApolloClient } from "@apollo/client";
import { Center, Loader } from "@mantine/core";
import { FC, useContext, useEffect } from "react";
import { AppContext } from "src/api/AppContext";
import { AcceptTAC } from "src/api/graphql/mutations/User";
import {
  AcceptTacMutation,
  AcceptTacMutationVariables,
} from "src/generated/graphql";
import TermsAndConditions from "../../components/TermsAndConditions";

const EmployeeOnboarding: FC = () => {
  const { query, mutate } = useApolloClient();
  const { currentUser, refetchUserData } = useContext(AppContext);

  useEffect(() => {}, []);

  const handleCheckTerms = async () => {
    try {
      const response = await mutate<
        AcceptTacMutation,
        AcceptTacMutationVariables
      >({ mutation: AcceptTAC });

      if (response.data?.acceptTAC) {
        refetchUserData();
      }
    } catch (err) {
      throw err;
    }
  };

  const renderNextStep = () => {
    if (!currentUser?.acceptedTAC) {
      return (
        <TermsAndConditions
          handleCheckTerms={handleCheckTerms}
        ></TermsAndConditions>
      );
    }
    return (
      <div>
        <Loader />{" "}
      </div>
    );
  };

  return renderNextStep();
};

export default EmployeeOnboarding;
